<template>
  <div class="bg-background-academy text-center py-6 text-white
  flex items-center font-sans-serif">
    <h1 class="w-full p-4
    font-bold tracking-widest uppercase text-md">
      {{ sentence }}
    </h1>
    <button class="absolute right-1 top-1" @click="$emit('close')">
      <close-icon class="w-3" />
    </button>
  </div>
</template>

<script>
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  props: ['sentence'],

  components: {
    CloseIcon,
  },

};
</script>
